import { Component, EventEmitter, Input, Output} from '@angular/core';
import { Card } from './../../models/card';


@Component({
  selector: 'memory-card',
  templateUrl: './memory-card.component.html',
  styleUrls: ['./memory-card.component.css']
})
export class MemoryCardComponent  {

  back= 'url("../../../assets/goals/squareEarth.png")';
  @Input() card: Card;
 
  //new event emitter: 'select'
  @Output() select= new EventEmitter();

  constructor() { }

  onClick() {
    if(this.card.flipped) {
      return;
    }
    //emit 'select' with card as payload
    this.select.emit(this.card)
 
  }
 
}
